import React from 'react';
import { privacyContent } from '../data/privacyContent';
import './LegalPage.css';

const Privacy: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container-narrow">
        <div className="legal-header">
          <h1 className="legal-title">개인정보처리방침</h1>
          <p className="legal-subtitle">
            {privacyContent.serviceName} 개인정보처리방침
          </p>
          <p className="legal-date">시행일자: {privacyContent.effectiveDate}</p>
        </div>

        <div className="legal-content">
          <div className="legal-intro">
            <p>
              {privacyContent.companyName}(이하 "회사")는 개인정보 보호법 제30조에 따라
              정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록
              하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
            </p>
          </div>

          {privacyContent.sections.map((section, index) => (
            <div key={index} className="legal-section">
              <h2 className="section-heading">{section.title}</h2>
              <div className="section-content" style={{ whiteSpace: 'pre-line' }}>
                {section.content}
              </div>
            </div>
          ))}

          <div className="legal-section company-info">
            <h2 className="section-heading">회사 정보</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">회사명</span>
                <span className="info-value">{privacyContent.companyName}</span>
              </div>
              <div className="info-item">
                <span className="info-label">대표자</span>
                <span className="info-value">{privacyContent.companyInfo.ceo}</span>
              </div>
              <div className="info-item">
                <span className="info-label">사업자등록번호</span>
                <span className="info-value">{privacyContent.companyInfo.businessNumber}</span>
              </div>
              <div className="info-item">
                <span className="info-label">본사 / 연구소</span>
                <span className="info-value">{privacyContent.companyInfo.headquarters}</span>
              </div>
              <div className="info-item">
                <span className="info-label">서울사무소</span>
                <span className="info-value">{privacyContent.companyInfo.researchLab}</span>
              </div>
              <div className="info-item">
                <span className="info-label">전화</span>
                <span className="info-value">{privacyContent.companyInfo.tel}</span>
              </div>
              <div className="info-item">
                <span className="info-label">팩스</span>
                <span className="info-value">{privacyContent.companyInfo.fax}</span>
              </div>
              <div className="info-item">
                <span className="info-label">이메일</span>
                <span className="info-value">{privacyContent.companyInfo.email}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
